// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Link from "../components/Link/Link.bs.js";
import * as Prose from "../components/Prose/Prose.bs.js";
import * as React from "react";
import * as Button from "../components/Button/Button.bs.js";
import * as Emotion from "../bindings/Emotion.bs.js";
import * as Excerpt from "../lib/Excerpt.bs.js";
import * as Skeleton from "../components/Skeleton/Skeleton.bs.js";
import * as DateFormat from "../lib/DateFormat.bs.js";
import * as Typography from "../components/Typography/Typography.bs.js";
import * as ArticleMeta from "../components/ArticleMeta/ArticleMeta.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";
import * as RescriptRelay_Query from "rescript-relay/src/RescriptRelay_Query.bs.js";
import * as PostPageQuery_graphql from "../__generated__/PostPageQuery_graphql.bs.js";
import * as RescriptReactErrorBoundary from "@rescript/react/src/RescriptReactErrorBoundary.bs.js";

let convertVariables = PostPageQuery_graphql.Internal.convertVariables;

let convertResponse = PostPageQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = PostPageQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, PostPageQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, PostPageQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(PostPageQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(PostPageQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(PostPageQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(PostPageQuery_graphql.node, convertVariables);

let PostQuery = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function PostPage$EntryNav(props) {
  let href = "/posts/" + props.id;
  return JsxRuntime.jsxs(Link.Link.make, {
    href: href,
    variant: "nav",
    className: Emotion.Css.css({
      display: "flex",
      flexDirection: "column",
      gap: "0.35rem",
      textAlign: props.align === "right" ? "right" : "left",
      minWidth: "0",
      flex: "1"
    }),
    children: [
      JsxRuntime.jsx(Typography.Typography.Overline.make, {
        children: props.label
      }),
      JsxRuntime.jsx(Typography.Typography.Body.make, {
        className: Emotion.Css.css({
          color: Emotion.Utils.Color.textPrimary,
          margin: "0"
        }),
        children: props.title
      })
    ]
  });
}

let EntryNav = {
  make: PostPage$EntryNav
};

function PostPage$Article(props) {
  let data = use({
    id: props.id
  }, undefined, undefined, undefined);
  let post = data.post;
  if (post === undefined) {
    return JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(Typography.Typography.Heading.make, {
          level: "h2",
          children: "Entry not found"
        }),
        JsxRuntime.jsx(Typography.Typography.Body.make, {
          className: Emotion.Css.css({
            color: Emotion.Utils.Color.textSecondary
          }),
          children: "This piece is no longer in the journal."
        }),
        JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(Button.Button.make, {
            variant: "outline",
            onClick: param => RescriptReactRouter.push("/posts"),
            children: "Back to Posts"
          }),
          className: Emotion.Css.css({
            marginTop: "1.5rem"
          })
        })
      ]
    });
  }
  let index = data.posts.findIndex(entry => entry.id === post.id);
  let newer = index > 0 ? data.posts[index - 1 | 0] : undefined;
  let older = index >= 0 ? data.posts[index + 1 | 0] : undefined;
  return JsxRuntime.jsxs("article", {
    children: [
      JsxRuntime.jsxs(Prose.Prose.make, {
        dropCap: true,
        children: [
          JsxRuntime.jsx(ArticleMeta.ArticleMeta.make, {
            author: post.author.name,
            date: DateFormat.formatLong(post.createdAt)
          }),
          JsxRuntime.jsx(Prose.Prose.Title.make, {
            children: post.title
          }),
          Excerpt.paragraphs(post.body).map((paragraph, index) => JsxRuntime.jsx(Prose.Prose.Paragraph.make, {
            children: paragraph
          }, index.toString()))
        ]
      }),
      JsxRuntime.jsxs("div", {
        children: [
          older !== undefined ? JsxRuntime.jsx(PostPage$EntryNav, {
              id: older.id,
              label: "Older",
              title: older.title,
              align: "left"
            }) : JsxRuntime.jsx("span", {}),
          newer !== undefined ? JsxRuntime.jsx(PostPage$EntryNav, {
              id: newer.id,
              label: "Newer",
              title: newer.title,
              align: "right"
            }) : JsxRuntime.jsx("span", {})
        ],
        className: Emotion.Css.css({
          display: "flex",
          justifyContent: "space-between",
          gap: "2rem",
          maxWidth: "65ch",
          marginTop: "3.5rem",
          paddingTop: "2rem",
          borderTop: `1px solid ` + Emotion.Utils.Color.border
        })
      }),
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Link.Link.make, {
          href: "/posts",
          variant: "subtle",
          children: "All posts"
        }),
        className: Emotion.Css.css({
          marginTop: "2rem"
        })
      })
    ]
  });
}

let Article = {
  make: PostPage$Article
};

function PostPage(props) {
  let containerStyles = Emotion.Css.css({
    padding: "4rem 1rem 6rem",
    maxWidth: "720px",
    margin: "0 auto"
  });
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(RescriptReactErrorBoundary.make, {
      children: JsxRuntime.jsx(React.Suspense, {
        children: JsxRuntime.jsx(PostPage$Article, {
          id: props.id
        }),
        fallback: JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(Skeleton.Skeleton.make, {
              variant: "title"
            }),
            JsxRuntime.jsx(Skeleton.Skeleton.Stack.make, {
              count: 5
            })
          ],
          className: Emotion.Css.css({
            display: "flex",
            flexDirection: "column",
            gap: "1rem"
          })
        })
      }),
      fallback: param => JsxRuntime.jsx(Typography.Typography.Body.make, {
        className: Emotion.Css.css({
          color: Emotion.Utils.Color.textSecondary
        }),
        children: "Unable to load this entry."
      })
    }),
    className: containerStyles
  });
}

let Typography$1;

let Button$1;

let Skeleton$1;

let Prose$1;

let ArticleMeta$1;

let Link$1;

let make = PostPage;

export {
  PostQuery,
  Typography$1 as Typography,
  Button$1 as Button,
  Skeleton$1 as Skeleton,
  Prose$1 as Prose,
  ArticleMeta$1 as ArticleMeta,
  Link$1 as Link,
  EntryNav,
  Article,
  make,
}
/* use Not a pure module */
